/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  StaticContentPlugin,
  IStaticContentPluginMethods,
  LoadingContentPlugin,
  ILoadingContentPluginMethods,
  ErrorContentPlugin,
  IErrorContentPluginMethods,
  IFHPCalculatorPluginMethods,
  FHPCalculatorPlugin,
  IKYCFormDataMethods,
  KYCFormDataPlugin,
  IKYCSubmitMethods,
  KYCSubmitPlugin,
  ISendOTPMethods,
  SendOTPPlugin,
  ISignInUserMethods,
  SignInUserPlugin,
  IGetAccessTokenMethods,
  GetAccessTokenPlugin,
  ICreatePolicyMethods,
  CreatePolicyPlugin,
  ICreateOrderMethods,
  CreateOrderPlugin,
  IDisplayRazorPayMethods,
  DisplayRazorPayPlugin,
  IHeaderNavContentMethods,
  HeaderNavContentService,
} from './plugins';

export type TAgent = IStaticContentPluginMethods &
  ILoadingContentPluginMethods &
  IErrorContentPluginMethods &
  IFHPCalculatorPluginMethods &
  IKYCFormDataMethods &
  IKYCSubmitMethods &
  ISendOTPMethods &
  ISignInUserMethods &
  IGetAccessTokenMethods &
  ICreatePolicyMethods &
  ICreateOrderMethods &
  IDisplayRazorPayMethods &
  IHeaderNavContentMethods;

const getPlugins = () => {
  return [
    new StaticContentPlugin(),
    new ErrorContentPlugin(),
    new LoadingContentPlugin(),
    //Business logic plugins !
    new FHPCalculatorPlugin(),
    new KYCFormDataPlugin(),
    new KYCSubmitPlugin(),
    new SendOTPPlugin(),
    new SignInUserPlugin(),
    new GetAccessTokenPlugin(),
    new CreatePolicyPlugin(),
    new CreateOrderPlugin(),
    new DisplayRazorPayPlugin(),
    new HeaderNavContentService(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
